import { SubmitButton } from '@capsule/consumer-design-system';

import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';
import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import { FormikCheckboxTick } from 'src/app/components/Form/FormikCheckboxTick';

export const InputContainer = styled.div`
  width: 100%;
`;

export const ContinueSection = styled.div`
  display: flex;
  margin-top: ${props => props.theme.space['2.0']} !important;
`;

export const ContinueButton = styled(Button)`
  width: 100% !important;
  ${props => props.theme.mediaQueries.medium} {
    width: 50% !important;
  }
`;

export const FamilyButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: ${props => props.theme.space['2.6']} !important;
`;

export const FamilyButton = styled(LinkButton)`
  text-align: left !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
`;

export const Checkbox = styled(FormikCheckboxTick)`
  margin-top: 4.8rem;
  ${props => props.theme.mediaQueries.smallDown} {
    margin-top: 3.2rem;
  }
  margin-bottom: 2.4rem;
`;

export const StylizedSubmitButton = styled(SubmitButton)`
  margin-top: 4.8rem;
  ${props => props.theme.mediaQueries.smallDown} {
    margin-top: 3.2rem;
  }
`;
